import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { KTCard, allCategory } from '../../../../../../_metronic/helpers'
// import {roleColumns} from './_columns'
import { roleColumns } from './_columnsC'
import { initialQueryState } from '../../../../../../_metronic/helpers'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getUserById } from '../../../data-administration/data-admininstration-list/core/_requests'
import { useQueryRequest } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'

const QualityList = () => {
  const { data } = useQuery(
    `clients/101212/categories`,
    () => getUserById('', 'clients/101212/categories'),
    {
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )
  const { updateState } = useQueryRequest()

  // const [categoriesList, setCategoriesList] = useState([{label: 'Select one', value: ''}])
  // useEffect(() => {
  //   if (data && data.length) {
  //     let dropdownData: any = []
  //     data.map((eachData) => {
  //       return dropdownData.push({label: eachData.name, value: eachData.id})
  //     })
  //     setCategoriesList(dropdownData)
  //     updateState({
  //       enabled: true,
  //       initialApi: `categories/${dropdownData[0].value}/price`,
  //       ...initialQueryState,
  //     })
  //   }
  // }, [data])

  // const searchElements = [
  //   {
  //     type: 'select',
  //     queryType: 'price',
  //     value: 'select',
  //     options: categoriesList,
  //   },
  // ]

  return (
    <KTCard>
      {/* <UsersListHeader  label='Add new' placeholder='Search' /> */}
      <UsersTable columnProps={roleColumns} />
      <UserEditModal formName='ProcessingRouteModallForm' />
    </KTCard>
  )
}

const IsccProcessingRoutesWrapper = () => (
  // <QueryRequestProvider initialValue={{enabled: false}}>
  <QueryRequestProvider initialValue={{ initialApi: 'materialProcesses' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <QualityList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { IsccProcessingRoutesWrapper }
